export default __webpack_public_path__ + "static/media/longshirtBekoBayi.252e5f7e.jpg";